import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { FaFacebook } from "react-icons/fa";

const ServiceBox = ({ service }) => {
  return (
    <div className="flex flex-col items-start justify-start rounded-lg bg-white p-4 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-800">{service.Title}</h3>
      <div
        dangerouslySetInnerHTML={{
          __html: service.Description,
        }}
        className="mt-3 w-full rounded-md bg-gray-50 p-3 text-left text-sm text-gray-700"
      ></div>
      <div className="mt-4 flex w-full items-center justify-between">
        <span className="text-sm text-gray-500">
          {new Date(service.DateCreated).toLocaleDateString()}
        </span>
        <span
          className={`text-sm ${service.ServiceProvided ? "text-green-500" : "text-red-500"}`}
        >
          {service.ServiceProvided ? "Completed" : "Pending"}
        </span>
      </div>
    </div>
  );
};

function ServiceStatus() {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchServices = async () => {
      try {
        const response = await axios.get(
          "https://genz-staging.feeltiptop.com/api/feed/get_all_services",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (isMounted && response.data.status === true) {
          setMessage("Services fetched successfully ");
          setServices(response.data.data);
        }
      } catch (error) {
        if (isMounted) {
          if (error.response && error.response.data && error.response.data.message) {
            setError(error.response.data.message);
          } else {
            setError("Error fetching services");
          }
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchServices();

    return () => {
      isMounted = false;
      setError("");
    };
  }, []);

  return (
    <div className="flex max-h-full w-full flex-col items-center justify-center overflow-y-auto">
      {loading ? (
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex flex-col items-center gap-2">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
            <p className="text-gray-600">Loading services...</p>
          </div>
        </div>
      ) : services.length > 0 ? (
        <div className="h-full w-full max-w-3xl">
          <div className="mb-4 rounded-lg bg-white px-2 py-4">
            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              All Your Services
            </h2>
            <hr />
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              {services.map((service, index) => (
                <ServiceBox key={index} service={service} />
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex w-full max-w-md flex-col items-center rounded-lg bg-white p-8 text-center shadow-sm">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="mb-4 h-16 w-16 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p className="text-gray-600">No completed services found.</p>
          <button className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700">
            Add New Service
          </button>
        </div>
      )}
    </div>
  );
}

export default ServiceStatus;
